export default "__VITE_ASSET__fSWBRIMj__"